export default [
  {
    id: 1,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    monDate: "9:11:01",
    tueDate: '9:25:16', 
    wedDate: '--',
    thuDate: '5:50:00',
    friDate: '0.00',
    satDate: '0.00',
    sunDate: '0.00',
    totalHours: '0.00',
    avgActivity: '50',
    totalAmount: '0.00',
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/150?img=2",
    name: "Ansh Jain",
    role: "UI/UX Designer",
    projectName: "Peak Quest",
    projectRole: "Research Lead",
    monDate: "9:11:01",
    tueDate: '9:25:16', 
    wedDate: '--',
    thuDate: '5:50:00',
    friDate: '0.00',
    satDate: '0.00',
    sunDate: '0.00',
    totalHours: '0.00',
    avgActivity: '50',
    totalAmount: '0.00',
  },
  {
    id: 3,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    monDate: "9:11:01",
    tueDate: '9:25:16', 
    wedDate: '--',
    thuDate: '5:50:00',
    friDate: '0.00',
    satDate: '0.00',
    sunDate: '0.00',
    totalHours: '0.00',
    avgActivity: '50',
    totalAmount: '0.00',
  },
  {
    id: 4,
    avatar: "https://i.pravatar.cc/150?img=2",
    name: "Ansh Jain",
    role: "UI/UX Designer",
    projectName: "Peak Quest",
    projectRole: "Research Lead",
   monDate: "9:11:01",
    tueDate: '9:25:16', 
    wedDate: '--',
    thuDate: '5:50:00',
    friDate: '0.00',
    satDate: '0.00',
    sunDate: '0.00',
    totalHours: '0.00',
    avgActivity: '50',
    totalAmount: '0.00',
  }
];
